import { useState } from "react";
import { SearchSelectProps } from "./SearchSelect.type";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import "./SearchSelect.css";

const INPUT_COLOR_ERROR = "red";

export default function SearchSelect({
  id,
  fieldName,
  label,
  required,
  error,
  onSelect,
  styles,
  readOnly,
  options,
  loading,
  customKey,
  width = "100%",
}: SearchSelectProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="SearchAutocomplete">
      <Autocomplete
        key={customKey}
        disablePortal
        clearOnEscape
        disableClearable
        className="relative"
        disabled={readOnly}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        onChange={(_e, value, reason) => {
          onSelect && reason === "selectOption" && onSelect(value);
        }}
        open={isOpen}
        onOpen={() => {
          setIsOpen(true);
        }}
        onClose={() => {
          setIsOpen(false);
        }}
        id={id}
        options={options || []}
        loading={loading}
        renderInput={(params) => (
          <>
            <TextField
              className={styles}
              {...params}
              name={fieldName}
              label={label}
              required={required}
              InputProps={{
                ...params.InputProps,

              }}
              sx={{ width }}
            />
            {/* ERRORS MESSAGE */}
            {error?.message && (
              <span style={{ color: INPUT_COLOR_ERROR }}>{error?.message}</span>
            )}
            {error?.type === "required" && (
              <span style={{ color: INPUT_COLOR_ERROR }}>
                Seleccionar opción válida*
              </span>
            )}
          </>
        )}
      />
    </div>
  );
}
